export enum DeviceType {
    Apple = 'apple',
    Android = 'android',
}